module.exports = __webpack_public_path__ + "6f82fc579b906b31ab0c27a720a5f886.png";